// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"landing-module--wrapper--3mUHh","textsWrapper":"landing-module--textsWrapper--1vBGl","imageWrapper":"landing-module--imageWrapper--2-_FX"};